import { ValidTelemetryEvent, Telemetry } from '../../../commonInfra/services/Telemetry';

export enum VizSpaceTelemetryEvents {
  VisitAlertFromEmail = 'VisitAlertFromEmail',
}

interface VisitAlertFromEmailEventParams {
  alert_evaluation_state: string;
  alert_id: string;
  view_id: string;
  workbook_id: string;
  site_role: string;
}

export interface VisitAlertFromEmailEvent extends VisitAlertFromEmailEventParams, ValidTelemetryEvent<VisitAlertFromEmailEvent> {
  type: VizSpaceTelemetryEvents.VisitAlertFromEmail;
}

export function sendVisitAlertFromEmailTelemetry(params: VisitAlertFromEmailEventParams) {
  Telemetry.sendEvent<VisitAlertFromEmailEvent>({
    type: VizSpaceTelemetryEvents.VisitAlertFromEmail,
    ...params
  });
}
